/* import __COLOCATED_TEMPLATE__ from './empty-state.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */
import Component from '@glimmer/component';
import type AppService from 'embercom/services/app-service';
import { inject as service } from '@ember/service';
import type ReportingChartService from 'embercom/services/reporting-chart-service';

export interface EmptyStateArgs {
  openStandaloneSideDrawer: () => void;
}

export default class EmptyState extends Component<EmptyStateArgs> {
  @service declare appService: AppService;
  @service declare reportingChartService: ReportingChartService;
  get shouldShowZendeskConnectScreen() {
    if (!this.appService.app.isStandaloneApp || this.reportingChartService.useSyntheticData) {
      return false;
    }

    if (
      this.appService.app.hasStandalonePlatform('zendesk') &&
      !this.appService.mainStandalonePlatform.isConnected
    ) {
      return true;
    }

    return (
      this.appService.app.hasStandalonePlatform('zendesk') &&
      this.appService.mainStandalonePlatform.showAnalyzeSectionConnectCta
    );
  }

  get shouldShowSalesforceConnectScreen() {
    if (!this.appService.app.isStandaloneApp || this.reportingChartService.useSyntheticData) {
      return false;
    }

    if (
      this.appService.app.hasStandalonePlatform('salesforce') &&
      !this.appService.mainStandalonePlatform.isConnected
    ) {
      return true;
    }

    return (
      this.appService.app.hasStandalonePlatform('salesforce') &&
      this.appService.mainStandalonePlatform.showAnalyzeSectionConnectCta
    );
  }

  get emptyState() {
    return this.shouldShowZendeskConnectScreen || this.shouldShowSalesforceConnectScreen;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::Optimize::EmptyState': typeof EmptyState;
    'reporting/automation/ai-insights/optimize/empty-state': typeof EmptyState;
  }
}
